// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","resultTable":"NCy08GQ0QTCaobp0rBryB"};